export default "__VITE_ASSET__Bkaw6kkX__"